const StorageKeys = {
  VEHICLE_ID: 'vehicleId',
  VEHICLE_OPERATION_SCHEDULE_ID: 'vehicleOperationScheduleId',
  DIGIDEN_AREA: 'digidenArea',
};

export default StorageKeys;
